import assets from '../assets';
import { sound } from '../core/sound';

const React = require('react');
const { connect } = require('react-redux');
const Title = require('./title').default;
const Game = require('./game').default;
const Debug = require('./debug').default;
const { getNextPorinBox } = require('../core/stageData').default;
const { sceneType } = require('../define/screenType').default;
const style = require('./app.style').default;


class application extends React.Component {
    componentWillMount() { }

    componentDidMount() { }

    renderScreenView(scene) {
        let sceneView = undefined;
        switch (scene) {
            case sceneType.SCENE_TITLE:
                sceneView = (
                    <Title />
                )
                break;
            case sceneType.SCENE_GAME:
                sceneView = (
                    <Game updateInterval={250} />
                )
                break;
            case sceneType.SCENE_DEBUG:
            default:
                sceneView = (
                    <Debug />
                )
                break;
        }
        return sceneView;
    }

    render() {
        const { screenState: { scene } } = this.props.state;
        // console.log(`### ${scene}`);
        return (
            <div className="noselect" style={style.applicationStyle}>

                {/* screen view */}
                {this.renderScreenView(scene)}

            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return { state };
};

export default connect(
    mapStateToProps
)(application);
